import { Component, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import {
  DataService,
  AuthService,
  ToasterService,
} from 'src/app/shared/services';
import { ConfFactorModel } from 'src/app/shared/models';
import { BsModalRef } from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { ComponentModel } from '../../../../shared/models';
import { validateNumberInput } from 'src/utils';

@Component({
  selector: 'app-conf-factor-edit',
  templateUrl: './edit.component.html',
})
export class ConfFactorEditComponent implements OnInit {
  // Modal parameters
  items: any; // array of items to edit
  boolReference: { value: boolean; name: string }[] = [];
  // form instance
  form!: UntypedFormGroup;

  // Usage mode
  mode: 'mass' | 'single' | 'new' = 'single';

  // Target Id's
  targetIds: number[] = [];

  // UI Flag
  isLoading = false;
  data = null;
  isSubmitted = false;
  showValidationError = false;

  // Form reference Data
  parentReference: any;

  /**
   * @param formBuilder
   * @param service
   * @param auth
   * @param bsModalRef
   * @param translate
   * @param toastr
   */
  constructor(
    private formBuilder: UntypedFormBuilder,
    protected service: DataService,
    public auth: AuthService,
    public bsModalRef: BsModalRef,
    public translate: TranslateService,
    private toastr: ToasterService
  ) {
    this.isLoading = true;
  }

  /**
   *
   */
  async ngOnInit(): Promise<void> {
    // Sniff mode
    this.mode = this.sniffEditMode(this.items);

    // get target Ids
    this.targetIds = _.map(this.items, (el) => el.id);

    // Get default empty object
    if (['mass', 'new'].indexOf(this.mode) > -1) {
      this.items = [
        new ConfFactorModel({
          account: this.auth.getAccountId(),
        }),
      ];
    }

    // Build for
    this.form = this.getForm(this.items[0]);

    // Loading done !
    this.isLoading = false;
  }

  /**
   * Sniff usage mode from items configuration
   */
  sniffEditMode(items: [ComponentModel?]): 'mass' | 'single' | 'new' {
    // Empty array => New Item
    if (items === undefined || items.length === 0) {
      return 'new';

      // Else => Single Edit
    } else {
      return 'single';
    }
  }

  /**
   *
   */
  getForm(item: ConfFactorModel): UntypedFormGroup {
    return this.formBuilder.group({
      id: new UntypedFormControl(item.id),
      description: new UntypedFormControl(item.description, [
        Validators.required,
        Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/),
      ]),
      failureProbability: new UntypedFormControl(item.failureProbability, [
        Validators.min(1),
      ]),
      mttrPercentage: new UntypedFormControl(item.mttrPercentage, [
        Validators.min(1),
      ]),
      mttrPlusMinus: new UntypedFormControl(item.mttrPlusMinus),
      account: new UntypedFormControl(this.auth.getAccountId()),
      noDowntime: new UntypedFormControl(item.noDowntime),
    });
  }

  validateNumberInput(event: KeyboardEvent): void {
    validateNumberInput(event);
  }

  /**
   * Confirm callback with updated res
   */
  confirmFn = (res: any) => {};

  /**
   *
   */
  save(): boolean | void {
    this.showValidationError = true;
    if (!this.form || (this.form && !this.form.valid)) {
      return false;
    } else {
      if (
        this.form.value?.failureProbability === null &&
        this.form.value?.mttrPercentage === null &&
        this.form.value?.mttrPlusMinus === null
      ) {
        const message = `${this.translate.instant(
          'messages.criticality.at_least_one_field_required'
        )} ${this.translate.instant(
          'headers.fastcr.criticality_calc_attr.failure_probability_factor'
        )}/${this.translate.instant(
          'headers.risk_parameters.finalities.mttr_percentage'
        )}/${this.translate.instant(
          'headers.risk_parameters.finalities.mttr_plus_minus'
        )}`;
        this.toastr.showError(message);
        return;
      }

      // Query pointer
      let query;

      if (this.mode === 'new') {
        const tmpData = _.pickBy(this.form.value, (el) => el !== null);
        query = this.service.post('api/config/factors', tmpData);
      } else if (this.mode === 'single') {
        query = this.service.update(
          'api/config/factors',
          this.targetIds[0],
          this.form.value
        );
      }

      this.isSubmitted = true;
      query?.subscribe(
        (res) => {
          this.isSubmitted = false;
          this.confirmFn(res);
          this.bsModalRef.hide();
        },
        (err) => {
          console.log('err: ', err);
          this.isSubmitted = false;
        }
      );
    }
  }
}
